import Repository from './Repository'

const resource = '/statistics'

export default {
  async updateWorkerStatistic(phone, fromId) {
    try {
      return await Repository.put(`${resource}/update-worker-statistic/${phone}/${fromId}`, {})
    } catch (e) {
      return this.setErrors(e)
    }
  },
  setErrors (e) {
    const errorCode = e.response ? e.response.status : 500
    return {
      status: false,
      errorCode: errorCode,
      data: e.response ? e.response.data : 'error',
      error: e
    }
  },
  catchError (e) {
    return e.response ? e.response.data : 'error'
  }
}
